/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Price_RentInputs */

const cs_col_price_rent = /** @type {(inputs: Col_Price_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nájem / měsíc`)
};

const en_col_price_rent = /** @type {(inputs: Col_Price_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent / Month`)
};

/**
* | output |
* | --- |
* | "Rent / Month" |
*
* @param {Col_Price_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_price_rent = /** @type {((inputs?: Col_Price_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Price_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_price_rent(inputs)
	return cs_col_price_rent(inputs)
});